import React from 'react'
import { Modal } from '@enamelai/design-system'
import { Icon as Delete2Icon } from '@enamelai/design-system/icons/Delete2'

type FaxDeleteNumberModalProps = {
  show: boolean
  faxNumber: string
  onCancel: () => void
  onDelete: () => void
}

const FaxDeleteNumberModal: React.FC<FaxDeleteNumberModalProps> = ({
  show,
  faxNumber,
  onCancel,
  onDelete,
}) => {
  const numberLabel = faxNumber.trim() || 'this number'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      closeOnBackdrop={false}
      size="sm"
      variant="confirmation"
      title="Delete fax number"
      icon={<Delete2Icon width={16} height={16} aria-hidden="true" />}
      iconTone="danger"
      description={[
        `Are you sure you want to delete the fax number ${numberLabel}?`,
        'Once deleted, this number will be permanently deactivated and removed from fax settings.',
        'Deleting this number means you can no longer:',
      ]}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      onPrimaryClick={() => {
        onDelete()
        onCancel()
      }}
      onSecondaryClick={onCancel}
    >
      <ul className="ds-modal__list">
        <li>Send or receive faxes</li>
      </ul>
      <p className="ds-modal__description">This action can&apos;t be undone.</p>
    </Modal>
  )
}

export default FaxDeleteNumberModal
